<div class="promotional-code" *ngIf="(isMobile === false  && isTablet === false) && getUser()">
  <div class="text">
    <p>¿Tienes un código de descuento? ingrésalo aquí</p>
  </div>
  <div class="input">
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <input appToUppercase appCodePromo maxlength="40" formControlName="code" autocomplete="off" matInput type="text">
        <mat-error>Código incompleto.</mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
<div class="promotional-movil" *ngIf="(isMobile === true  || isTablet === true) && getUser()">
  <div class="text">
    <p>¿Tienes un código de descuento?<br>Ingrésalo aquí</p>
  </div>
  <div class="input">
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <input appToUppercase appCodePromo maxlength="40" formControlName="code" autocomplete="off" matInput type="text">
        <mat-error>Código incompleto.</mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
<div class="succes-movil" *ngIf="succesCodigo && (isMobile === true  || isTablet === true)">
  {{succesCodigo}}
</div>
<div class="succes" *ngIf="succesCodigo && isMobile === false  && isTablet === false">
  {{succesCodigo}}
</div>
<div class="error-movil" *ngIf="errorCodigo && (isMobile === true  || isTablet === true)">
  {{errorCodigo}}
</div>
<div class="error" *ngIf="errorCodigo && isMobile === false  && isTablet === false">
  {{errorCodigo}}
</div>
